import flatten from "lodash/flatten";
import intersection from "lodash/intersection";

// compares wire values — the v3 configuration reads, the v3 runtime reads and
// the still-v1 search rows all share the same context-type strings
export const selectorIsContextTypesMatched = (
  sharedFileSettings?: { contextType?: string },
  contextTypes?: string | string[]
) => {
  return (
    intersection([sharedFileSettings?.contextType], flatten([contextTypes]))
      .length > 0
  );
};
